import i18n from './vue-i18n';
import './yup';
import './moment';
import ElementUI from './element-ui';

export default {
    i18n,
    ElementUI,
};
